import styled from 'styled-components';
export const Heading1 = styled.p`
  margin-bottom: 20px;
  padding-top: 130px;
  color: #212529;
  font-size: 72px;
  font-weight: 200;
  text-align: center;
`;
export const Heading2 = styled.h2`
  margin-bottom: 20px;
  font-family: Avenir Next, sans-serif;
  color: #375d75;
  font-size: 40px;
  font-weight: 600;
  text-align: center;
`;
export const Heading3 = styled.h3`
  font-size: 2rem;
  color: #212529;
  font-weight: bold;
`;
export const Heading4 = styled.p`
  font-family: Avernirnextitpro, sans-serif;
  color: #212529;
  font-size: 20px;
  margin: 10px 0 0;
  line-height: 1.2;
`;
export const Div2 = styled.div`
  width: 75%;
  display: flex;
  gap: 200px;
  justify-content: space-evenly;
  margin: auto;
`;
export const Dollar = styled.label`
  font-size: 40px;
  font-family: Avernirnextitpro, sans-serif;
  color: #212529;
`;
export const Dollar$ = styled.label`
  font-size: 80px;
  font-family: Avernirnextitpro, sans-serif;
  color: #212529;
`;
export const List = styled.li`
  font-size: 18px;
  font-family: Avernirnextitpro, sans-serif;
  color: #212529;
  margin: 0 0 20px;
`;
export const Buttons = styled.button`
  width: 400px;
  margin-left: -6em;
  padding: 10px;
  border: 1px solid grey;
  border-radius: 5px;
  text-align: center;
  &:hover {
    background-color: #3b8fc2;
    border-color: #2cb1f0;
  }
`;
export const ProButton = styled.button`
  width: 400px;
  padding: 10px;
  border: 1px solid grey;
  border-radius: 5px;
  text-align: center;
  background-color: #3b8fc2;
  &:hover {
    background-color: #2cb1f0;
    border-color: #2cb1f0;
  }
`;
export const ButtonDiv = styled.div`
  display: flex;
  justify-content: space-evenly;
`;
export const Div3 = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const FAQdiv = styled.div`
  width: 75%;
  margin: auto;
  font-family: Avernirnextitpro, sans-serif;
`;
export const FeatureDiv = styled.div`
  width: 75%;
  margin: 50px auto;
`;
export const FAQtitle = styled.h2`
  width: fit-content;
  margin: 50px auto;
  font-family: Avenir Next, sans-serif;
  font-size: 40px;
  color: #375d75;
`;
export const Question = styled.h3`
  color: #212529;
  font-weight: 600;
  font-size: 18px;
`;
export const Answer = styled.p`
  color: #212529;
`;
export const TrHead = styled.tr`
  background-color: #f4f4f4;
  font-size: 18px;
  font-weight: bold;
  color: #212529;
`;
export const Td = styled.td`
  color: #000000;
  font-size: 16px;
  padding: 16px 10px 16px 0;
`;
export const Th = styled.th`
  font-size: 25px;
  padding: 16px 10px 16px 0;
`;
export const Review = styled.p`
  font-size: 56px;
  // padding: 40px 95px;
  color: #212529;
  font-weight: 0px;
`;
export const ReviewDiv = styled.div`
  width: 65%;
  padding: 40px 95px;
  margin: auto;
  background-color: #dceefa;
`;
export const MemberName = styled.p`
  padding: 0px 10px;
  font-size: 20px;
  color: #375d75;
`;
export const Value = styled.p`
  font-size: 72px;
  color: #375d75;
  margin-top: 0;
  font-weight: thin;
`;
export const H5 = styled.h5`
  text-align: center;
  color: #212529;
  margin-bottom: 0;
`;
